module.exports = require("./uz-Arab");